<div class="filter-panel d-flex align-items-center gap-3 flex-wrap">

  <!-- Title Search (First Item) -->
  <mat-form-field appearance="outline" class="filter-field flex-grow-1">
    <mat-label>Search Title or Subtitle</mat-label>
    <input matInput [(ngModel)]="searchText" placeholder="e.g. Sales or Line Chart">
  </mat-form-field>


  <!-- Measures Filter -->
  <mat-form-field appearance="outline" class="filter-field">
    <mat-label>Filter Measures</mat-label>
    <mat-select [(value)]="selectedMeasures" multiple>
      @for (m of allMeasures; track m) {
        <mat-option [value]="m">{{ m }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Dimensions Filter -->
  <mat-form-field appearance="outline" class="filter-field">
    <mat-label>Filter Dimensions</mat-label>
    <mat-select [(value)]="selectedDimensions" multiple>
      @for (d of allDimensions; track d) {
        <mat-option [value]="d">{{ d }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Clear All Button -->
  <!-- Clear All Button -->
  <div class="filter-field d-flex align-items-center">
    <button mat-stroked-button color="warn" class="clear-btn" (click)="clearFilters()">Clear All</button>
  </div>

  <div class="selected-summary ms-auto">
    <span class="caption">Selected Variants:</span>
    <span class="count">{{ selectedVariants?.length || 0 }}</span>
  </div>
  @if (selectedVariants?.length > 0) {
    <button mat-fab color="primary" class="fab-create-btn" (click)="createDashboard()"
      matTooltip="Create Dashboard">
      <mat-icon>create</mat-icon>
    </button>
  }
</div>


<mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChanged($event)">
  @for (type of chartTypes; track type; let tabIndex = $index) {
    <mat-tab
      [label]="type + ' (' + getFilteredCountByType(type) + ')'">
      <mat-paginator [length]="getFilteredCountByType(type)" [pageSize]="pageSize" [pageIndex]="pageIndex"
        (page)="onPageChange($event, type)">
      </mat-paginator>
      @if (selectedTabIndex === tabIndex) {
        <div class="row">
         @for (variant of currentPageVariants; let i = $index; track variant){
            <div class="col-3">
              <mat-card [class.selected]="isSelected(variant)" (click)="onVariantSelect(variant)"
                class="variant-card">
                <!-- Title with ellipsis -->
                <mat-card-title class="card-title-ellipsis" matTooltip="{{ variant.shortTitle }}">
                  {{ variant.shortTitle }} @if (isSelected(variant)) {
                  <mat-icon class="tick">check</mat-icon>
                }
              </mat-card-title>
              <!-- Subtitle -->
              <mat-card-subtitle>
                {{ variant.chartType }} - {{variant.selectedVariation}}
              </mat-card-subtitle>
              <img mat-card-image src="/assets/img/charts/{{variant.selectedVariation}}.png" alt="Chart">
              <!-- Content -->
              <mat-card-content class="p-0">
                <!-- <img [src]="'https://picsum.photos/id/237/200/300'" alt="Chart preview" class="w-100" /> -->
                <!-- <form (keydown.enter)="$event.preventDefault()" #fgForm="ngForm">
                <fg-form [formDataId]="variant.mockData" [formSchema]="variant.component"></fg-form>
              </form> -->
              @if (variant.component ) {
                <div class="row">
                  <div class="col-md-12">
                    <!-- <fg-form [formDataId]="{}" [formSchema]="variant.component"></fg-form> -->
                  </div>
                </div>
              }
            </mat-card-content>
            <!-- Footer: chart variation toggle -->
            <mat-card-actions class="chart-variant-actions" (click)="$event.stopPropagation()">
              <mat-button-toggle-group name="chartToggle-{{ variant.name }}"
                [(ngModel)]="variant.selectedVariation" appearance="standard"
                class="variant-toggle-chip-group">
                @for (v of variant.chartVariations; track v) {
                  <mat-button-toggle [value]="v"
                    class="variant-chip">
                    {{ getChartName(v) }}
                  </mat-button-toggle>
                }
              </mat-button-toggle-group>
            </mat-card-actions>
          </mat-card>
        </div>
      }
    </div>
  }
</mat-tab>
}
</mat-tab-group>

<div align="end">
  <button mat-button mat-dialog-close>Close</button>
</div>